/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDashBorderBottom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21 19v2H3v-2zm0-4v2h-2v-2zm0-4v2h-2v-2zm0-4v2h-2V7zm0-4v2h-2V3zm-4 8v2h-2v-2zm0-8v2h-2V3zm-4 12v2h-2v-2zm0-4v2h-2v-2zm0-4v2h-2V7zm0-4v2h-2V3zm-4 8v2H7v-2zm0-8v2H7V3zM5 15v2H3v-2zm0-4v2H3v-2zm0-4v2H3V7zm0-4v2H3V3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDashBorderBottom as DashBorderBottom };
